import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors, lightColorWithDarkTheme } from "../constants/GlobalStyles";

const IconCheckmark = (props: IconProps) => (
  <svg
    width={props.width || 24}
    height={props.height || 19}
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.9998 2.33312L7.99984 18.3331L0.666504 10.9998L2.5465 9.11979L7.99984 14.5598L22.1198 0.453125L23.9998 2.33312Z"
      fill={props.color || lightColorWithDarkTheme("black", colors.text.header)}
    />
  </svg>
);

export default IconCheckmark;
